import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store';
import {
  fetchPoints,
  createPoint as createPointAction,
  deletePoint as deletePointAction,
  updatePoint as updatePointAction,
} from '../store/pointsSlice';

export const usePoints = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { items, loading, error } = useSelector((state: RootState) => state.points);

  const fetchUserPoints = () => dispatch(fetchPoints()).unwrap();

  const createPoint = async (name: string) => {
    return dispatch(createPointAction(name)).unwrap();
  };

  const deletePoint = async (id: number) => {
    await dispatch(deletePointAction(id)).unwrap();
  };

  /**
   * Update a point's name and/or color.
   * Pass an empty string to leave a field unchanged.
   */
  const updatePoint = async (id: number, name: string, color?: string) => {
    await dispatch(updatePointAction({ id, name, color })).unwrap();
  };

  return {
    points: items,
    loading,
    error,
    fetchPoints: fetchUserPoints,
    createPoint,
    deletePoint,
    updatePoint,
  };
};